import React, { useState, useEffect } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Button, Container, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer } from 'common/components';

import * as actions from './actions';
import { ListItems } from './components';
import ProductFormRHF from './components/ProductFormRHF';
import * as selectors from './selectors';

const ParametersPanelsContainer = ({
    items,
    fetchItems,
    handleClickBulkItems,
    handleClickCreate,
    handleClickUpdate,
    handleDuplicate,
    handleSaveRow,
    isDuplicatingProduct,
    isFetching,
    isFetchingBulk,
    isOpenProductForm,
    pagination,
    reset,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        orderBy: null,
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: null,
        status: 'active',
    });

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);

    useEffect(() => {
        fetchItems(filterData);
    }, []);

    return (
        <>
            {!isOpenProductForm ? (
                <Container maxWidth={false}>
                    <HeaderContainer>
                        <Grid size="grow" textAlign="right">
                            <Button
                                onClick={() => handleClickCreate()}
                                startIcon={<AddIcon />}
                                sx={{ width: { xs: '100%', md: 'auto' } }}
                                type="button"
                            >
                                {t('Add')}
                            </Button>
                        </Grid>
                    </HeaderContainer>

                    <ListItems
                        filterData={filterData}
                        filterItems={fetchItems}
                        handleClickBulkItems={handleClickBulkItems}
                        handleClickDuplicate={(item) =>
                            handleDuplicate(filterData, item.id)
                        }
                        handleClickUpdate={(item) => handleClickUpdate(item)}
                        handleSaveRow={handleSaveRow}
                        isFetching={
                            isDuplicatingProduct || isFetching || isFetchingBulk
                        }
                        items={items}
                        paginationData={pagination}
                        setFilterData={setFilterData}
                    />
                </Container>
            ) : (
                <Container maxWidth="">
                    <ProductFormRHF
                        filterData={filterData}
                        handleClickBulkItems={handleClickBulkItems}
                    />
                </Container>
            )}
        </>
    );
};

ParametersPanelsContainer.propTypes = {
    items: PropTypes.array,
    fetchItems: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    handleDuplicate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isDuplicatingProduct: PropTypes.bool,
    isFetching: PropTypes.bool,
    isFetchingBulk: PropTypes.bool,
    isOpenProductForm: PropTypes.bool,
    pagination: PropTypes.object,
    reset: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    isDuplicatingItem: selectors.getIsDuplicatingItem,
    isFetching: selectors.getItemsIsFetching,
    isFetchingBulk: selectors.getIsFetchingBulk,
    isOpenProductForm: selectors.getIsOpenProductForm,
    pagination: selectors.getItemsPagination,
    items: selectors.getItemsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchItems: (filterData) => dispatch(actions.fetchItems(filterData)),
    handleClickBulkItems: (ids, value, filterData, callback) =>
        dispatch(actions.prepareBulkItems(ids, value, filterData, callback)),
    handleClickCreate: () => dispatch(actions.prepareCreate()),
    handleClickUpdate: (item) => dispatch(actions.prepareUpdate(item)),
    handleDuplicate: (filterData, id) =>
        dispatch(actions.duplicateItem(filterData, id)),
    handleSaveRow: (item) => dispatch(actions.bulkEditionRow(item)),
    reset: () => dispatch(actions.reset()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ParametersPanelsContainer);
